import useFetch, { FetchSpec, Error } from './useFetch';

export interface RequestSpec extends FetchSpec { }

export interface Request<Resp, Req> {
  isLoading: boolean,
  isError: boolean,
  isSuccess: boolean,
  request: (r: Req) => void,
  data: Resp | null,
  error: Error | null,
}

export interface RequestOptions<Resp = void> {
  onSuccess?: (resp: Resp) => void,
  onError?: (error: Error) => void,
  onComplete?: () => void,
}

export default function useRequest<Req, Resp = void>(
  spec: RequestSpec, options?: RequestOptions<Resp>): Request<Resp, Req> {

  const fetch = useFetch<Resp, Req>(spec, { ...options });
  const request = (r: Req) => fetch.fetch(r);

  return {
    isLoading: fetch.isLoading,
    isError: fetch.isError,
    isSuccess: fetch.isSuccess,
    data: fetch.data,
    error: fetch.error,
    request: request,
  };
}
